// extracted by mini-css-extract-plugin
export default {"container":"WalletBalanceCell_container__qLC+E","currencyIcon":"WalletBalanceCell_currencyIcon__9teGv","percentChange":"WalletBalanceCell_percentChange__Zca-3"};